import { render, staticRenderFns } from "./UploadPlusIcon.vue?vue&type=template&id=1d8b40d6&scoped=true"
import script from "./UploadPlusIcon.vue?vue&type=script&lang=ts"
export * from "./UploadPlusIcon.vue?vue&type=script&lang=ts"
import style0 from "./UploadPlusIcon.vue?vue&type=style&index=0&id=1d8b40d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b40d6",
  null
  
)

export default component.exports